import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { cn } from '@/utils/style'

type EIPBreadcrumbItem = {
  label: ReactNode
  to: string
  active?: boolean
}

interface EIPBreadcrumbProps {
  items: EIPBreadcrumbItem[]
}

export function EIPBreadcrumb({ items }: EIPBreadcrumbProps) {
  const navigate = useNavigate()

  return (
    <nav aria-label="breadcrumb" className="h6 flex items-center gap-2">
      {items.map((item, index) => (
        <span key={`${item.to}-${index}`} className="flex items-center gap-2">
          {index > 0 && <span className="text-tertiary">/</span>}
          <button
            type="button"
            className={cn(
              'cursor-pointer hover:text-primary',
              item.active ? 'text-primary' : 'text-tertiary',
            )}
            onClick={() => navigate(item.to)}
          >
            {item.label}
          </button>
        </span>
      ))}
    </nav>
  )
}
